'use client';
import { jsx } from 'react/jsx-runtime';
import classnames from '../../node_modules/classnames/index.js';
import { useRef } from 'react';
import { Context, fallbackLocale } from './ConstellationProvider.context.js';
import modules_8cf9a2b0 from './ConstellationProvider.module.scss.js';

const ConstellationProvider = ({ theme = "default", children, locale, }) => {
    const constellationProviderRef = useRef(null);
    return (jsx(Context.Provider, { value: {
            locale: fallbackLocale(locale),
            constellationProviderRef,
        }, children: jsx("div", { className: classnames(modules_8cf9a2b0.themeProvider, {
                [modules_8cf9a2b0[`theme-${theme}`]]: theme,
            }), "data-constellation-theme": theme, ref: constellationProviderRef, children: children }) }));
};

export { ConstellationProvider };
//# sourceMappingURL=ConstellationProvider.js.map
